import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { TicketReturnContext } from "../../aiTickets.types";
import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { requestTicketReturnContext } from "./ticketReturnContext.request";

// Only fetched once the agent opens the return form — the payload carries
// presigned media urls that expire, so there is no point holding it earlier.
const useTicketReturnContext = (ticketId: string | null) => {
  return useQuery<TicketReturnContext, ApiServiceError<ApiError>>({
    queryKey: [SUPPORT_TICKETS_QUERY_KEY, "return-context", ticketId],
    queryFn: async () => await requestTicketReturnContext(ticketId as string),
    enabled: !!ticketId,
    onError: toastServerError,
  });
};

export default useTicketReturnContext;
